import { render } from "./Rbac.vue?vue&type=template&id=2ec901a8"
import script from "./Rbac.vue?vue&type=script&lang=js"
export * from "./Rbac.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__